import { render } from "./WysiwygEditor.vue?vue&type=template&id=eced287c&scoped=true"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts"

import "./WysiwygEditor.vue?vue&type=style&index=0&id=eced287c&scoped=true&lang=scss"
import "./WysiwygEditor.vue?vue&type=style&index=1&id=eced287c&lang=scss"
script.render = render
script.__scopeId = "data-v-eced287c"

export default script